<template src="./Menu.html"> </template>

<script>
import MenuIcon from '@/components/Menu/MenuIcon/MenuIcon.vue';
import MenuTitle from '@/components/Menu/MenuTitle/MenuTitle.vue';
import MenuOption from '@/components/Menu/MenuOption/MenuOption.vue';
import MenuSelect from '@/components/Menu/MenuSelect/MenuSelect.vue';
import MenuList from '@/components/Menu/MenuList/MenuList.vue';
import MenuButton from '@/components/Menu/MenuButton/MenuButton.vue';

import { mapState, mapActions } from "vuex";


export default {
    name: 'ModuleMenu',
    props: {
        status: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    
    components: {
        MenuIcon,
        MenuTitle,
        MenuOption,
        MenuSelect,
        MenuList,
        MenuButton,
    },

    computed: {

        ...mapState({
            mapConfigOne: 'mapConfigOne',
            mapConfigTwo: 'mapConfigTwo',
        }),

        menuStatus: {

            get() {
                if (this.status) {
                    if (!this.menu) this.setMenu(false);
                    else this.setMenu(true);
                }
                return this.menu;
            },
            set(val) {
                this.menu = val;
            }
        }

    },

    data: () => ({
        menu: false,
        regionOfInterest: {
            items: [ {id: 'us', description: 'CONUS'}, {id: 'midwest', description: 'Midwest'}, {id: 'northeast', description: 'Northeast'}, {id: 'northern', description: 'Northern'}, {id: 'northwest', description: 'Northwest'}, {id: 'southeast', description: 'Southeast'} , {id: 'southern', description: 'Southern'}, {id: 'southwest', description: 'Southwest'}],
            itemSelected: 'us'
        },
        regionOfInterestSelect: 'Country',
        variables: {
            itemSelected: { id: 'totR', unit: 'in', layer: 1, threshold: '1', title: 'Total Precipitation' },
            items: [{
                action: 'fas fa-cloud-showers-heavy',
                items: [
                    { id: 'totR', unit: 'in', layer: 1, threshold: '1', title: 'Total Precipitation' }
                ],
                title: 'Precipitation',
            }, {
                action: 'fas fa-temperature-low',
                items: [
                    { id: 'minT', unit: 'f', layer: 1, threshold: '1', title: 'Minimum Temperature' },
                    { id: 'avgT', unit: 'f', layer: 1, threshold: '1', title: 'Average Temperature' },
                    { id: 'maxT', unit: 'f', layer: 1, threshold: '1', title: 'Maximum Temperature' },
                ],
                title: 'Air Temperature',
            },
            {
                action: 'fas fa-tint',
                items: [
                    { id: 'arid', threshold: '1', title: 'Average ARID' }
                ],
                title: 'Drought Index',
            },
            {
                action: 'fas fa-burn',
                items: [
                    //{ id: 'kdd', unit: 'f', layer: 1, threshold: 82, title: 'Maximum Temperature > 82ºF' },
                    { id: 'kdd', unit: '', layer: 2, threshold: 86, title: 'Stress Degree Days (86ºF)' },
                    { id: 'kdd', unit: '', layer: 3, threshold: 90, title: 'Stress Degree Days (90ºF)' },
                    { id: 'kdd', unit: '', layer: 4, threshold: 93, title: 'Stress Degree Days (93ºF)' },
                    { id: 'kdd', unit: '', layer: 5, threshold: 97, title: 'Stress Degree Days (97ºF)' },
                ],
                title: 'Heat Stress',
            },
            {
                action: 'fas fa-seedling',
                items: [
                    { id: 'gdd', unit: '', layer: 3, threshold: 40, title: 'Growing Degree Day (40ºF)' },
                    { id: 'gdd', unit: '', layer: 2, threshold: 50, title: 'Growing Degree Day (50ºF)' },
                    { id: 'gdd', unit: '', layer: 1, threshold: 60, title: 'Growing Degree Day (60ºF)' }
                ],
                title: 'Growing Degree Days',
             },
             {
                action: 'far fa-snowflake',
                items: [
                    { id: 'chillH', unit: '', layer: 1, threshold: [32, 45], title: 'Chill Hours (32ºF - 45ºF)' },
                ],
                title: 'Chill Accumulation',
            },
            {
                action: 'fas fa-thermometer',
                items: [
                    { id: 'thi', unit: '', layer: 1, threshold: '1', title: 'Temperature-Humidity Index' },
                ],
                title: 'Temperature-Humidity Index',
            }]
        },
        timePeriods: {
            itemSelected: '30',
            options: [{id: '0', description: 'Last Day'}, {id: '2', description: '2 Days'}, {id: '3', description: '3 Days'}, {id: '7', description: '7 Days'}, {id: '15', description: '15 Days'}, {id: '30', description: '30 Days'}, {id: '45', description: '45 Days'}, {id: '60', description: '60 Days'}, {id: '90', description: '90 Days'}, {id: '120', description: '120 Days'}, {id: '150', description: '150 Days'}]
        },
        timePeriodSelected: 0,
        timePeriodBegin: '2021-01-01',
        timePeriodEnd: '2021-01-31'
        
    }),
    methods: {

        ...mapActions({
            setMenuPeriod: "setMenuPeriod",
            setMenuSettings: 'setMenuSettings',
            setAlert: 'setAlert',

            setMapOne: 'setMapConfigOne',
            setMapTwo: 'setMapConfigTwo',
        }),

        setMenu(val) {
            this.menu = val
        },

        loadMapLayer: function() {
            
            if (this.timePeriods.itemSelected == '') {
                this.setAlert({message: 'Please select a Time Period!', type: 'error'});
                return;
            }

            if (this.regionOfInterest.itemSelected == '') {
                this.setAlert({message: 'Please select a Region of Interest!', type: 'error'});
                return;
            }

            if (this.variables.itemSelected == '') {
                this.setAlert({message: 'Please select a Variable!', type: 'error'});
                return;
            }

            this.setMenuSettings({
                geoid: this.regionOfInterest.itemSelected, 
                variable: this.variables.itemSelected,
                period: { 
                    period: this.timePeriods.itemSelected
                }
            });

            let toSetLayerOne = this.variables.itemSelected.id;
            if (this.mapConfigOne.layer != '') {
                let tp = this.mapConfigOne.layer.substring(this.mapConfigOne.layer.length - 3, this.mapConfigOne.layer.length)
                if (tp == 'Dev' || tp == 'His')
                    toSetLayerOne += tp;
            }

            let map1 = {
                url: this.variables.itemSelected.id == 'thi'  ? '' : 'https://wms.agroclimate.org/wms?geoid=' + this.regionOfInterest.itemSelected + '&band=' + this.variables.itemSelected.layer + '&period=' + this.timePeriods.itemSelected + "&date=20210713",
                layer: toSetLayerOne,
                visibility: this.mapConfigOne.visibility
            };

            let toSetLayerTwo = this.variables.itemSelected.id;
            if (this.mapConfigTwo.layer != '') {
                let tp = this.mapConfigTwo.layer.substring(this.mapConfigTwo.layer.length - 3, this.mapConfigTwo.layer.length)
                if (tp == 'Dev' || tp == 'His')
                    toSetLayerTwo += tp;
            }

            let map2 = {
                url: this.mapConfigTwo.layer != '' ? 
                        this.variables.itemSelected.id == 'thi'  ? '' : 'https://wms.agroclimate.org/wms?geoid=' + this.regionOfInterest.itemSelected + '&band=' + this.variables.itemSelected.layer + '&period=' + this.timePeriods.itemSelected + "&date=20210713" 
                    : '',
                layer: toSetLayerTwo,
                visibility: this.mapConfigTwo.visibility
            };

            this.setMapOne(map1);
            this.setMapTwo(map2);

        },
    },

    mounted() {
        
        let map1 = {
            url: 'https://wms.agroclimate.org/wms?geoid=' + this.regionOfInterest.itemSelected + '&band=' + this.variables.itemSelected.layer + '&period=' + this.timePeriods.itemSelected + "&date=20210713",
            layer: this.variables.itemSelected.id,
            visibility: true
        };

        this.setMapOne(map1);

        this.setMenuSettings({
            geoid: 'us', 
            variable: { id: 'totR', unit: 'in', layer: 1, threshold: '1', title: 'Total Precipitation' },
            period: { 
                period: 30
            }
        });
        
    },
}
</script>

<style lang="scss" src="./Menu.scss"> </style>
